import { useTheme } from '@emotion/react';
import { useMemo } from 'react';
import type { StepLineColor, StepLineColorScheme } from '.';

export const useColorSchemes = () => {
  const { color } = useTheme();

  const colorSchemes = useMemo(
    (): Record<StepLineColor, StepLineColorScheme> => ({
      light: {
        done: {
          dotBackground: color.blue.default,
          dotColor: color.light.default,
          labelColor: color.blue.default,
          descriptionColor: color.light.default,
          lineColor: color.light.default,
        },
        current: {
          dotBackground: color.light.default,
          dotColor: color.blue.default,
          labelColor: color.blue.default,
          descriptionColor: color.light.default,
          lineColor: color.light.default,
        },
        next: {
          dotBackground: color.light.default,
          dotColor: color.blue.default,
          labelColor: color.blue.default,
          descriptionColor: color.light.default,
          lineColor: color.light.default,
        },
        error: {
          dotBackground: color.red.default,
          dotColor: color.light.default,
          labelColor: color.blue.default,
          descriptionColor: color.light.default,
          lineColor: color.light.default,
        },
      },
      // TODO
      dark: {
        done: {
          dotBackground: color.blue.lightBlue,
          dotColor: color.blue.default,
          labelColor: color.blue.default,
          descriptionColor: color.medium.default,
          lineColor: color.light.shadeLighter,
        },
        current: {
          dotBackground: color.blue.default,
          dotColor: color.light.default,
          labelColor: color.blue.default,
          descriptionColor: color.medium.default,
          lineColor: color.light.shadeLighter,
        },
        next: {
          dotBackground: color.light.default,
          dotColor: color.blue.default,
          labelColor: color.blue.default,
          descriptionColor: color.medium.default,
          lineColor: color.light.shadeLighter,
        },
        error: {
          dotBackground: color.red.default,
          dotColor: color.light.default,
          labelColor: color.blue.default,
          descriptionColor: color.medium.default,
          lineColor: color.light.shadeLighter,
        },
      },
    }),
    [color],
  );

  return { colorSchemes };
};
